module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 96.8ef289b8.png";